import React from "react";
import { SHELL } from "@/api/connectorPackClient";

export default function EHRIngestionLogTable({ entries }) {
  return (
    <div style={SHELL.panel} data-testid="ehr-ingestion-log">
      <h2 style={SHELL.h2}>Ingestion Log · {(entries || []).length} entries</h2>
      <table style={{ ...SHELL.table, marginTop: 8 }}>
        <thead>
          <tr>
            <th style={SHELL.th}>Vendor</th>
            <th style={SHELL.th}>Resource</th>
            <th style={SHELL.th}>Status</th>
            <th style={SHELL.th}>Code</th>
            <th style={SHELL.th}>Received</th>
          </tr>
        </thead>
        <tbody>
          {(entries || []).map((e) => (
            <tr key={e._id}>
              <td style={SHELL.td}>{e.vendor_id}</td>
              <td style={SHELL.td}>{e.normalized?.resource_type}</td>
              <td style={SHELL.td}><span style={SHELL.badge()}>{e.normalized?.status || "—"}</span></td>
              <td style={SHELL.td}>{e.normalized?.code || "—"}</td>
              <td style={SHELL.td}>{(e.created_at || "").slice(0, 19)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
